
// THIS FILE IS AUTOGENERATED AS PART OF THE EXTENSION AND MODE PLUGIN PROCESS.
// IT SHOULD NOT BE MODIFIED MANUALLY 
const extensions = [];
const modes = [];

// Not required any longer
window.extensions = extensions;
window.modes = modes;

extensions.push("@ohif/extension-cornerstone");
extensions.push("@ohif/extension-measurement-tracking");
extensions.push("@ohif/extension-cornerstone-dicom-sr");
extensions.push("@vindr/extension-cornerstone-dicom-ko");
extensions.push("@ohif/extension-default");
extensions.push("@ohif/extension-dicom-microscopy");
extensions.push("@ohif/extension-dicom-pdf");
extensions.push("@vindr/extension-dicom-xml");
extensions.push("@ohif/extension-dicom-html");
extensions.push("@ohif/extension-dicom-video");
extensions.push("@ohif/extension-tmtv");
extensions.push("@ohif/extension-cornerstone-dicom-seg");
extensions.push("@vindr/extension");
extensions.push("@vindr/extension-vindr-report");
extensions.push("@vindr/extension-empty-viewport");
extensions.push("@vindr/extension-dicom-ecg");
modes.push("@vindr/mode-default");
modes.push("@vindr/mode-patient");
modes.push("@vindr/mode-shared");
modes.push("@vindr/mode-consultation");
modes.push("@ohif/mode-microscopy");


// Add a dynamic runtime loader
async function loadModule(module) {
  if (typeof module !== 'string') return module;
  if( module==="@ohif/extension-cornerstone") {
    const imported = await import("@ohif/extension-cornerstone");
    return imported.default;
  }
  if( module==="@ohif/extension-measurement-tracking") {
    const imported = await import("@ohif/extension-measurement-tracking");
    return imported.default;
  }
  if( module==="@ohif/extension-cornerstone-dicom-sr") {
    const imported = await import("@ohif/extension-cornerstone-dicom-sr");
    return imported.default;
  }
  if( module==="@vindr/extension-cornerstone-dicom-ko") {
    const imported = await import("@vindr/extension-cornerstone-dicom-ko");
    return imported.default;
  }
  if( module==="@ohif/extension-default") {
    const imported = await import("@ohif/extension-default");
    return imported.default;
  }
  if( module==="@ohif/extension-dicom-microscopy") {
    const imported = await import("@ohif/extension-dicom-microscopy");
    return imported.default;
  }
  if( module==="@ohif/extension-dicom-pdf") {
    const imported = await import("@ohif/extension-dicom-pdf");
    return imported.default;
  }
  if( module==="@vindr/extension-dicom-xml") {
    const imported = await import("@vindr/extension-dicom-xml");
    return imported.default;
  }
  if( module==="@ohif/extension-dicom-html") {
    const imported = await import("@ohif/extension-dicom-html");
    return imported.default;
  }
  if( module==="@ohif/extension-dicom-video") {
    const imported = await import("@ohif/extension-dicom-video");
    return imported.default;
  }
  if( module==="@ohif/extension-tmtv") {
    const imported = await import("@ohif/extension-tmtv");
    return imported.default;
  }
  if( module==="@ohif/extension-cornerstone-dicom-seg") {
    const imported = await import("@ohif/extension-cornerstone-dicom-seg");
    return imported.default;
  }
  if( module==="@vindr/extension") {
    const imported = await import("@vindr/extension");
    return imported.default;
  }
  if( module==="@vindr/extension-vindr-report") {
    const imported = await import("@vindr/extension-vindr-report");
    return imported.default;
  }
  if( module==="@vindr/extension-empty-viewport") {
    const imported = await import("@vindr/extension-empty-viewport");
    return imported.default;
  }
  if( module==="@vindr/extension-dicom-ecg") {
    const imported = await import("@vindr/extension-dicom-ecg");
    return imported.default;
  }
  if( module==="@vindr/mode-default") {
    const imported = await import("@vindr/mode-default");
    return imported.default;
  }
  if( module==="@vindr/mode-patient") {
    const imported = await import("@vindr/mode-patient");
    return imported.default;
  }
  if( module==="@vindr/mode-shared") {
    const imported = await import("@vindr/mode-shared");
    return imported.default;
  }
  if( module==="@vindr/mode-consultation") {
    const imported = await import("@vindr/mode-consultation");
    return imported.default;
  }
  if( module==="@ohif/mode-microscopy") {
    const imported = await import("@ohif/mode-microscopy");
    return imported.default;
  }
  if( module==="dicom-microscopy-viewer") {
    const imported = await window.browserImportFunction('/dicom-microscopy-viewer/dicomMicroscopyViewer.min.js');
    return window["dicomMicroscopyViewer"];
  }
  return (await window.browserImportFunction(module)).default;
}

// Import a list of items (modules or string names)
// @return a Promise evaluating to a list of modules
export default function importItems(modules) {
  return Promise.all(modules.map(loadModule));
}

export { loadModule, modes, extensions, importItems };

